const configService = {
    Axios: {
        baseURL: {
            // production: 'https://api.laidianxiu.top',
            // development: 'https://api-test.laidian.biku8.com',

            production: 'https://api.qingning6.com',
            // production: 'http://api-test.qingning6.com',
            // test: 'http://api-test.qingning6.com',
            // development: 'http://localhost:8081',
            // development: 'https://api-test.qingning6.com',
            development: 'https://api.qingning6.com',
        }
    },
};
export default configService